import { SchemaOrgContent, SchemaOrgItemProp, SchemaOrgItemType } from '@headless-workspace/config';
import { Component } from '@headless-workspace/typings';

type VariantMetadataProps = {
    id: string;
    name?: string;
    url?: string;
    isAvailable: boolean;
    price?: number;
    currency: string;
};

export const VariantMetadata: Component<VariantMetadataProps> = ({ id, name, url, isAvailable, price, currency }) => {
    return (
        <div
            itemProp={SchemaOrgItemProp.Offers}
            itemScope
            itemType={SchemaOrgItemType.Offer}
            className={'hidden'}
            aria-hidden
        >
            <meta itemProp={SchemaOrgItemProp.Price} content={price?.toString()} />
            <meta itemProp={SchemaOrgItemProp.PriceCurrency} content={currency} />
            <meta itemProp={SchemaOrgItemProp.Url} content={url} />
            <meta
                itemProp={SchemaOrgItemProp.Availability}
                content={isAvailable ? SchemaOrgContent.InStock : SchemaOrgContent.OutOfStock}
            />
            {/* FIXME: should be removed if click and collect is disabled */}
            <meta itemProp={SchemaOrgItemProp.AvailableDeliveryMethod} content={SchemaOrgContent.OnSitePickup} />
            <div itemProp={SchemaOrgItemProp.DeliveryLeadTime} itemScope itemType={SchemaOrgItemType.QuantitativeValue}>
                <meta itemProp={SchemaOrgItemProp.Value} content={'0'} />
            </div>
            <meta itemProp={SchemaOrgItemProp.Sku} content={id} />
            {name && <meta itemProp={SchemaOrgItemProp.Name} content={name} />}
        </div>
    );
};
